import type { AppState } from 'src/app/store'
import { AuthSliceState } from 'src/core/models'

const authState: AuthSliceState = {
  register: {
    create: {
      loading: false,
      success: false,
      error: null
    },
    step: 1,
    credentials: {
      email: null,
      password: null,
      confirmPassword: null
    },
    rol: 'COMPANY',
    personalDetails: {
      firstName: null,
      lastName: null,
      phone: null,
      companyName: null,
      companySize: null,
      country: null
    },
    rols: {
      isOffsetter: true,
      isProducer: false,
      isWidget: false,
      hasCommercialCommunications: false,
    }
  },
  forgotPassword: {
    loading: false,
    success: false,
    error: null
  },
  restorePassword: {
    loading: false,
    success: false,
    error: null
  },
  login: {
    loading: false,
    success: false,
    error: null
  },
  verifyEmail: {
    loading: false,
    success: false,
    error: null
  },
  completeInfo: {
    step: 1,
    confirmSellerRol: true,
    reasonToRegister: null,
    companyPosition: null,
    identityDocument: null,
    powerOfAttorney: null,
    companyDocumentation: null,
  },
  completeInfoSubmit: {
    loading: false,
    success: false,
    error: null
  },
  verifyToken: {
    redirectLogin: false
  }
}

export const selectedRegisterStep = (state: AppState): number => state.auth.register.step
export const userRolsSelector = (state: AppState) => state.auth.register.rols
export const userRolSelector = (state: AppState) => state.auth.register.rol
export const registerUserStateSelector = (state: AppState) => state.auth.register
export const registerUserSelector = (state: AppState) => state.auth.register.create

export { authState as initialState }
